/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_OfficeInputs */

const en_pc_cmp_r_office = /** @type {(inputs: Pc_Cmp_R_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word, Excel and PowerPoint`)
};

const zh_pc_cmp_r_office = /** @type {(inputs: Pc_Cmp_R_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word、Excel 与 PowerPoint`)
};

/**
* | output |
* | --- |
* | "Word, Excel and PowerPoint" |
*
* @param {Pc_Cmp_R_OfficeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_office = /** @type {((inputs?: Pc_Cmp_R_OfficeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_OfficeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_office(inputs)
	return zh_pc_cmp_r_office(inputs)
});
export { pc_cmp_r_office as "pc.cmp.r.office" }